<fgb-banner [pageTitle]="'wallet.page.title'"></fgb-banner>

<div class="wallet-header d-lg-none" #walletHeader>
  <div class="wallet-header-row d-flex align-items-center">
    <a
      class="btn back-btn text-white p-0"
      [routerLink]="'/'"
      attr.aria-label="{{ 'wallet.back.screenreader' | translate : { fgbdefault: 'Move to home page' } }}"
    >
      <span class="icon material-icons" aria-hidden="true">arrow_back_ios</span>
    </a>
    <h4 class="wallet-header-title text-white mb-0">
      {{ 'wallet.page.title' | translate : { fgbdefault: 'Redemption History' } }}
    </h4>
  </div>

  <div class="wallet-header-collapsible" id="walletHeaderCollapsible" [attr.inert]="isCollapsed ? '' : null">
    <div class="wallet-header-collapsible-inner" #walletCollapsibleInner>
      <fgb-barcode [showBarcode]="true"></fgb-barcode>

      <fgb-payment-button></fgb-payment-button>
    </div>
  </div>

  <button
    type="button"
    class="wallet-sheet-edge"
    aria-controls="walletHeaderCollapsible"
    [attr.aria-expanded]="!isCollapsed"
    attr.aria-label="{{ 'wallet.sheet.toggle.screenreader' | translate : { fgbdefault: 'Show or hide member barcode' } }}"
    (click)="onSheetEdgeClick()"
  >
    <span class="wallet-sheet-handle" aria-hidden="true"></span>
  </button>
</div>

<div class="d-none d-lg-block">
  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
</div>

<!-- V2 Wallet -->
<ng-container *ngIf="walletItems$ | async as walletItems">
  <ng-container *ngIf="walletItems.length > 0; else noWalletItems">
    <div class="wallet-redeem-carousel pt-0">
      <div class="container">
        <fgb-upgrade-banner></fgb-upgrade-banner
        ><fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #noWalletItems>
  <div class="container">
    <fgb-upgrade-banner></fgb-upgrade-banner>
    <h4 class="no-wallet-items mt-30 mb-3 text-uppercase font-size-20">{{ 'rewards.wallet.no.items' | translate }}</h4>
    <div class="border rounded no-wallet-border">
      <div class="no-wallet-items-description font-size-12 text-center py-3">
        {{ 'rewards.wallet.no.items.description' | translate }}
      </div>
    </div>
  </div>
</ng-template>

<div class="container mt-30 text-center mb-5">
  <div class="claimed-button bg-white d-flex p-3 border-radius-16 align-items-center">
    <div class="claimed-button-text text-start">
      <h6 class="font-size-18 font-page-heading text-uppercase mb-1">{{ 'rewards.wallet.claimed.reward.title' | translate }}</h6>
      <div class="font-size-14">{{ 'rewards.wallet.claimed.reward.subtitle' | translate }}</div>
    </div>
    <a class="font-size-14 claimed-text font-heading btn bg-white border-radius-16" [routerLink]="['/rewards/claimed']">
      {{ 'rewards.wallet.view.claimed' | translate }}
    </a>
  </div>
</div>
